import React, {FunctionComponent, useEffect, useState} from 'react'
import {useTranslation} from 'react-i18next'
import moment, {Moment} from 'moment'

import Client from './Client/Client'
import ReportTable from './ReportTable'
import Spinner from '../../App/Components/Spinner/Spinner'
import {IResult} from './Client/IResult'
import Chart from './ReportTable/Chart/Chart'
import CompareDateRangeSelection from '../CompareDateRangeSelection/CompareDateRangeSelection'

const SimpleDayReceiptReport: FunctionComponent = () => {
    const {t} = useTranslation()
    const [result1, setResult1] = useState<IResult | null>(null)
    const [result2, setResult2] = useState<IResult | null>(null)
    const [isLoading, setIsLoading] = useState<boolean>(false)

    const [from1, setFrom1] = useState<Moment>(moment().startOf('isoWeek'))
    const [to1, setTo1] = useState<Moment>(moment().endOf('isoWeek'))
    const [from2, setFrom2] = useState<Moment | null>(null)
    const [to2, setTo2] = useState<Moment | null>(null)

    const [span, setSpan] = useState<string>('week')

    const fetchData = async () => {
        setIsLoading(true)

        const newResult1 = await Client.getData(from1, to1)
        const newResult2 = from2 && to2 ? await Client.getData(from2, to2) : null

        setResult1(newResult1)
        setResult2(newResult2)
        setIsLoading(false)
    }

    useEffect(
        () => {
            fetchData()
        },
        [from1, to1, from2, to2, span]
    )

    const getContent = () => {
        return <div>
            <CompareDateRangeSelection
                onSelected={
                    (newSpan, range1, range2) => {
                        setSpan(newSpan)
                        setFrom1(range1.from)
                        setTo1(range1.to)
                        if (range2) {
                            setFrom2(range2.from)
                            setTo2(range2.to)
                        } else {
                            setResult2(null)
                        }
                    }
                }
                from={from1}
                to={to1}
                availableSpans={['week', 'month', 'year']}
            />

            {isLoading || null === result1
                ? <Spinner/>
                : <>
                    <Chart result1={result1} result2={result2} span={span}/>
                    <ReportTable results={[result1, result2].filter(Boolean)} span={span}/>
                </>
            }
        </div>
    }

    return <>
        <h1>{t('Simple day receipts')}</h1>

        {getContent()}
    </>
}

export default SimpleDayReceiptReport
